module.exports = __webpack_public_path__ + "img/specials-multislider-honda.3898479d.png";